import { useState } from 'react';

const usePagination = (mutate, id, initialPageSize = 10) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [totalItems, setTotalItems] = useState(0);

  const handlePageChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setCurrentPage(page);
    setPageSize(pageSize);

    mutate({ id, currentPage: page, pageSize });
  };

  return {
    currentPage,
    pageSize,
    totalItems,
    setTotalItems,
    handlePageChange,
    setCurrentPage,
  };
};

export default usePagination;
